/** 404 page for old paths (T037): /dashboard, /trading, etc. — no redirect. */
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8">
      <h1 className="text-3xl font-bold text-foreground">404</h1>
      <p className="text-muted-foreground">This page could not be found.</p>
      <Button asChild variant="outline">
        <Link to="/">Back to launcher</Link>
      </Button>
    </div>
  );
}
